/**
 * MeetingAttendanceStatusService
 * Service for MeetingAttendanceStatus entity operations
 * Route: api/meetingattendancestatuses
 * Controller: MeetingAttendanceStatusesController.cs
 */
import { CrudService } from '../base/CrudService';
/**
 * MeetingAttendanceStatusService
 * Handles meeting attendance status CRUD operations
 * Maps to /api/meetingattendancestatuses endpoint
 */
export class MeetingAttendanceStatusService extends CrudService {
    constructor(http, config) {
        super(http, {
            servicePath: config?.servicePath ?? MeetingAttendanceStatusService.DEFAULT_SERVICE_PATH,
            basePath: MeetingAttendanceStatusService.BASE_PATH,
            endpoints: config?.endpoints,
        });
    }
}
MeetingAttendanceStatusService.DEFAULT_SERVICE_PATH = 'meetings';
MeetingAttendanceStatusService.BASE_PATH = 'api/meetingattendancestatuses';
//# sourceMappingURL=MeetingAttendanceStatusService.js.map